import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography, Space } from 'antd';
import { UserOutlined, LockOutlined, CrownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/request';

const { Title, Text } = Typography;

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await request.post('/admin/login', {
        username: values.username,
        password: values.password
      });

      if (response.data.success) {
        // 存储管理员令牌
        localStorage.setItem('admin_token', response.data.data.access_token);
        localStorage.setItem('admin_user', JSON.stringify(response.data.data.user));
        
        message.success('管理员登录成功');
        navigate('/admin/dashboard');
      } else {
        message.error(response.data.message || '登录失败');
      }
    } catch (error) {
      console.error('管理员登录错误:', error);
      message.error(error.response?.data?.detail || '登录失败，请检查用户名和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      backgroundColor: '#f0f2f5'
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <CrownOutlined style={{ fontSize: 48, color: '#1890ff' }} />
          <Title level={2} style={{ margin: '16px 0', color: '#1890ff' }}>
            管理员后台
          </Title>
          <Text type="secondary">请使用管理员账户登录</Text>
        </div>

        <Form
          name="admin_login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入管理员用户名' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="管理员用户名"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入管理员密码' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="管理员密码"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 48 }}
            >
              登录管理后台
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Button 
            type="link" 
            onClick={() => navigate('/')}
            style={{ padding: 0 }}
          >
            返回用户端
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;